import { render, staticRenderFns } from "./ProductlLengthwidthList.vue?vue&type=template&id=18e939ba&scoped=true"
import script from "./ProductlLengthwidthList.vue?vue&type=script&lang=js"
export * from "./ProductlLengthwidthList.vue?vue&type=script&lang=js"
import style0 from "./ProductlLengthwidthList.vue?vue&type=style&index=0&id=18e939ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e939ba",
  null
  
)

export default component.exports